<template>
  <div class="productService">
    <mobileConsult />
    <consult />
    <toTop />
      
    <div class="home-wrapper01">
      <div class="wrapper01-main">
        <!-- <div class="text01">高效—协同—智能</div> -->
        <div class="text02">爱开IDrive</div>
        <div class="text03">助力出行行业数字化转型</div>
      </div>
    </div>

    <div class="index_home-wrapper02">
      <div class="wrapper02-main">
        <div class="wrapper02-main01">
          <div><img class="img01" src="../assets/images/product_service02.png"/></div>
        </div>
        <div class="wrapper02-main02">最新产品体验</div>
        <div class="wrapper02-main03">所有最新功能第一时间使用</div>
      </div>
      <div class="wrapper02-main">
        <div class="wrapper02-main01">
          <div><img class="img01" src="../assets/images/product_service03.png"/></div>
        </div>
        <div class="wrapper02-main02">免部署</div>
        <div class="wrapper02-main03">注册即用,0运维成本</div>
      </div>
      <div class="wrapper02-main">
        <div class="wrapper02-main01">
          <div><img class="img01" src="../assets/images/product_service04.png"/></div>
        </div>
        <div class="wrapper02-main02">企业级数据安全防护</div>
        <div class="wrapper02-main03">保证数据安全</div>
      </div>
    </div>

    <!-- 专为出行行业数字化而设计 start -->
    <section class="indedx_design">
        <div class="container">
            <div class="row">
                <h2 class="col-md-12 text-center title" aos="fade-down">专为出行行业数字化而设计</h2>
                <div class="col-md-12 design_title" role="tablist" aos="fade-down">
                    <div class="design_title_item active" href="#design_a" role="tab" data-toggle="tab">
                        <div class="img_box"></div>
                        <h5>司机管理</h5>
                    </div>

                    <div class="design_ani_item">
                        <div class="arrow"><em></em></div>
                        <div class="arrow"><em></em></div>
                        <div class="arrow"><em></em></div>
                    </div>

                    <div class="design_title_item" href="#design_b" role="tab" data-toggle="tab">
                        <div class="img_box"></div>
                        <h5>车辆管理</h5>
                    </div>

                    <div class="design_ani_item">
                        <div class="arrow"><em></em></div>
                        <div class="arrow"><em></em></div>
                        <div class="arrow"><em></em></div>
                    </div>

                    <div class="design_title_item" href="#design_c" role="tab" data-toggle="tab">
                        <div class="img_box"></div>
                        <h5>订单管理</h5>
                    </div>

                    <div class="design_ani_item">
                        <div class="arrow"><em></em></div>
                        <div class="arrow"><em></em></div>
                        <div class="arrow"><em></em></div>
                    </div>

                    <div class="design_title_item" href="#design_d" role="tab" data-toggle="tab">
                        <div class="img_box"></div>
                        <h5>财务管理</h5>
                    </div>

                    <div class="design_ani_item">
                        <div class="arrow"><em></em></div>
                        <div class="arrow"><em></em></div>
                        <div class="arrow"><em></em></div>
                    </div>

                    <div class="design_title_item" href="#design_e" role="tab" data-toggle="tab">
                        <div class="img_box"></div>
                        <h5>数据报表</h5>
                    </div>

                </div>

            </div>

            <div class="swiper m_design_swiper" aos="fade-down">
                <div class="row design_content tab-content swiper-wrapper">
                    <div class="design_content_item tab-pane active swiper-slide" id="design_a">
                        <h2 class="m_tit">司机管理</h2>
                        <div class="item_title_box design_a" role="tablist">
                            <div class="item_title active" href="#design_a_01" role="tab" data-toggle="tab">
                                <h4>资质信息管理</h4>
                                <p>身份证、驾驶证、服务资格证等相关证件的核验有效期实时监控</p>
                                <!-- <div class="link_box">
                                    <a onclick="window.open('https://www.finereport.com/product/functions/designer')"
                                      href="https://www.finereport.com/product/functions/designer" target="_blank">了解更多<i
                                                class="iconfont icon-right-1-copy"></i></a>
                                    <a onclick="window.location.href='https://www.finereport.com/product/active'"
                                      href="https://www.finereport.com/product/active" rel="nofollow"
                                      class="gtm-index-cta">免费使用<i class="iconfont icon-xiazai"></i></a>
                                </div> -->
                            </div>
                            <div class="item_title" href="#design_a_02" role="tab" data-toggle="tab">
                                <h4>违章记录管理</h4>
                                <p>运管违章记录、交警违章记录</p>
                                <!-- <div class="link_box">
                                    <a onclick="window.open('https://www.finereport.com/product/functions/designer')"
                                      href="https://www.finereport.com/product/functions/designer" target="_blank">了解更多<i
                                                class="iconfont icon-right-1-copy"></i></a>
                                    <a onclick="window.location.href='https://www.finereport.com/product/active'"
                                      href="https://www.finereport.com/product/active" rel="nofollow"
                                      class="gtm-index-cta">免费使用<i class="iconfont icon-xiazai"></i></a>
                                </div> -->
                            </div>
                            <div class="item_title" href="#design_a_03" role="tab" data-toggle="tab">
                                <h4>经营管理</h4>
                                <p>协议管理、签到记录、请假记录</p>
                                <!-- <div class="link_box">
                                    <a onclick="window.open('https://www.finedatalink.com/')"
                                      href="https://www.finedatalink.com/" target="_blank">了解更多<i
                                                class="iconfont icon-right-1-copy"></i></a>
                                    <a onclick="window.location.href='https://www.fanruan.com/actionform?action=active-ft&utm_source=gw&utm_medium=frgw&utm_campaign=1&utm_term=finetube'"
                                      href="https://www.fanruan.com/actionform?action=active-ft&utm_source=gw&utm_medium=frgw&utm_campaign=1&utm_term=finetube"
                                      rel="nofollow">联系我们<i class="iconfont icon-right-1-copy"></i></a>
                                </div> -->
                            </div>
                        </div>
                        <div class="item_content_box tab-content design_a_content">
                            <div class="item_content tab-pane active" id="design_a_01">
                                <img class="img-responsive center-block"
                                    src="../assets/images/product_service10.png"
                                    alt="帆软报表,FineReport,报表系统,报表软件,报表工具,报表开发工具,数据报表,web报表,java报表,B/S报表,免费报表工具,类excel报表,数据分析工具,BI报表">
                            </div>
                            <div class="item_content tab-pane" id="design_a_02">
                                <img class="img-responsive center-block"
                                    src="../assets/images/product_service11.png"
                                    alt="帆软报表,FineReport,报表系统,报表软件,报表工具,报表开发工具,数据报表,web报表,java报表,B/S报表,免费报表工具,类excel报表,数据分析工具,BI报表">
                            </div>
                            <div class="item_content tab-pane" id="design_a_03">
                                <img class="img-responsive center-block"
                                    src="../assets/images/product_service12.png"
                                    alt="帆软报表,FineReport,报表系统,报表软件,报表工具,报表开发工具,数据报表,web报表,java报表,B/S报表,免费报表工具,类excel报表,数据分析工具,BI报表">
                            </div>
                        </div>
                    </div>
                    <div class="design_content_item tab-pane swiper-slide" id="design_b">
                        <h2 class="m_tit">车辆管理</h2>
                        <div class="item_title_box design_b" role="tablist">
                            <div class="item_title active" href="#design_b_01" role="tab" data-toggle="tab">
                                <h4>资质信息管理</h4>
                                <p>车辆信息、道路运输证、经营权证、行驶证等相关证件的核验有效期实时监控</p>
                                <!-- <div class="link_box">
                                    <a onclick="window.open('https://www.finereport.com/product/functions/datareport')"
                                      href="https://www.finereport.com/product/functions/datareport" target="_blank">了解更多<i
                                                class="iconfont icon-right-1-copy"></i></a>
                                    <a onclick="window.location.href='https://www.finereport.com/product/active'"
                                      href="https://www.finereport.com/product/active" rel="nofollow"
                                      class="gtm-index-cta">免费使用<i class="iconfont icon-xiazai"></i></a>
                                </div> -->
                            </div>
                            <div class="item_title" href="#design_b_02" role="tab" data-toggle="tab">
                                <h4>违章记录管理</h4>
                                <p>运管违章记录、交警违章记录</p>
                                <!-- <div class="link_box">
                                    <a onclick="window.open('https://www.finereport.com/product/functions/datareport')"
                                      href="https://www.finereport.com/product/functions/datareport" target="_blank">了解更多<i
                                                class="iconfont icon-right-1-copy"></i></a>
                                    <a onclick="window.location.href='https://www.finereport.com/product/active'"
                                      href="https://www.finereport.com/product/active" rel="nofollow"
                                      class="gtm-index-cta">免费使用<i class="iconfont icon-xiazai"></i></a>
                                </div> -->
                            </div>
                            <div class="item_title" href="#design_b_03" role="tab" data-toggle="tab">
                                <h4>经营管理</h4>
                                <p>车辆年检、车辆保险、车辆维修、车辆事故等业务管理</p>
                                <!-- <div class="link_box">
                                    <a onclick="window.open('https://www.finereport.com/product/functions/datareport')"
                                      href="https://www.finereport.com/product/functions/datareport" target="_blank">了解更多<i
                                                class="iconfont icon-right-1-copy"></i></a>
                                    <a onclick="window.location.href='https://www.finereport.com/product/active'"
                                      href="https://www.finereport.com/product/active" rel="nofollow"
                                      class="gtm-index-cta">免费使用<i class="iconfont icon-xiazai"></i></a>
                                </div> -->
                            </div>
                        </div>
                        <div class="item_content_box tab-content design_b_content">
                            <div class="item_content tab-pane active" id="design_b_01">
                                <img class="img-responsive center-block"
                                    src="../assets/images/product_service13.png"
                                    alt="帆软报表,FineReport,报表系统,报表软件,报表工具,报表开发工具,数据报表,web报表,java报表,B/S报表,免费报表工具,类excel报表,数据分析工具,BI报表">
                            </div>
                            <div class="item_content tab-pane" id="design_b_02">
                                <div class="embed-responsive embed-responsive-16by9">
                                    <img class="img-responsive center-block"
                                        src="../assets/images/product_service14.png"
                                        alt="帆软报表,FineReport,报表系统,报表软件,报表工具,报表开发工具,数据报表,web报表,java报表,B/S报表,免费报表工具,类excel报表,数据分析工具,BI报表">
                                </div>
                            </div>
                            <div class="item_content tab-pane" id="design_b_03">
                                <img class="img-responsive center-block"
                                    src="../assets/images/product_service15.png"
                                    alt="帆软报表,FineReport,报表系统,报表软件,报表工具,报表开发工具,数据报表,web报表,java报表,B/S报表,免费报表工具,类excel报表,数据分析工具,BI报表">
                            </div>
                        </div>
                    </div>
                    <div class="design_content_item tab-pane swiper-slide" id="design_c">
                        <h2 class="m_tit">订单管理</h2>
                        <div class="item_title_box design_c" role="tablist">
                            <div class="item_title active" href="#design_c_01" role="tab" data-toggle="tab">
                                <h4>租单管理</h4>
                                <p>支持单班、统班、月租订单创建，人车匹配唯一标识、车辆空置自动标识、人证异常状态标识</p>
                                <!-- <div class="link_box">
                                    <a onclick="window.open('https://www.finereport.com/product/functions/fill-output')"
                                      href="https://www.finereport.com/product/functions/fill-output"
                                      target="_blank">了解更多<i class="iconfont icon-right-1-copy"></i></a>
                                    <a onclick="window.location.href='https://www.finereport.com/product/active'"
                                      href="https://www.finereport.com/product/active" rel="nofollow"
                                      class="gtm-index-cta">免费使用<i class="iconfont icon-xiazai"></i></a>
                                </div> -->
                            </div>
                            <div class="item_title" href="#design_c_02" role="tab" data-toggle="tab">
                                <h4>订单自动延续</h4>
                                <p>订单自动创建配置，最长可自动创建30天，大大提升工作效率</p>
                                <!-- <div class="link_box">
                                    <a onclick="window.open('https://www.finereport.com/product/functions/canshu')"
                                      href="https://www.finereport.com/product/functions/canshu" target="_blank">了解更多<i
                                                class="iconfont icon-right-1-copy"></i></a>
                                    <a onclick="window.location.href='https://www.finereport.com/product/active'"
                                      href="https://www.finereport.com/product/active" rel="nofollow"
                                      class="gtm-index-cta">免费使用<i class="iconfont icon-xiazai"></i></a>
                                </div> -->
                            </div>
                            <div class="item_title" href="#design_c_03" role="tab" data-toggle="tab">
                                <h4>人车智能匹配推荐</h4>
                                <p>根据司机的相关地址，地图上做打点标识，智能辅助空置车辆和司机匹配。</p>
                                <!-- <div class="link_box">
                                    <a onclick="window.open('https://www.finereport.com/product/functions/datavisualization')"
                                      href="https://www.finereport.com/product/functions/datavisualization"
                                      target="_blank">了解更多<i class="iconfont icon-right-1-copy"></i></a>
                                    <a onclick="window.location.href='https://www.finereport.com/product/active'"
                                      href="https://www.finereport.com/product/active" rel="nofollow"
                                      class="gtm-index-cta">免费使用<i class="iconfont icon-xiazai"></i></a>
                                </div> -->
                            </div>
                        </div>
                        <div class="item_content_box tab-content design_c_content">
                            <div class="item_content tab-pane active" id="design_c_01">
                                <img class="img-responsive center-block"
                                    src="../assets/images/product_service16.png"
                                    alt="帆软报表,FineReport,报表系统,报表软件,报表工具,报表开发工具,数据报表,web报表,java报表,B/S报表,免费报表工具,类excel报表,数据分析工具,BI报表">
                            </div>
                            <div class="item_content tab-pane" id="design_c_02">
                                <img class="img-responsive center-block"
                                    src="../assets/images/product_service17.png"
                                    alt="帆软报表,FineReport,报表系统,报表软件,报表工具,报表开发工具,数据报表,web报表,java报表,B/S报表,免费报表工具,类excel报表,数据分析工具,BI报表">
                            </div>
                            <div class="item_content tab-pane" id="design_c_03">
                                <img class="img-responsive center-block"
                                    src="../assets/images/product_service18.png"
                                    alt="帆软报表,FineReport,报表系统,报表软件,报表工具,报表开发工具,数据报表,web报表,java报表,B/S报表,免费报表工具,类excel报表,数据分析工具,BI报表">
                            </div>
                        </div>
                    </div>
                    <div class="design_content_item tab-pane swiper-slide" id="design_d">
                        <h2 class="m_tit">财务管理</h2>
                        <div class="item_title_box design_d" role="tablist">
                            <div class="item_title active" href="#design_d_01" role="tab" data-toggle="tab">
                                <h4>账户分类管理</h4>
                                <p>用户余额、车主押金、司机保证金等分类管理，每笔操作都有详细记录，安全可靠。</p>
                                <!-- <div class="link_box">
                                    <a onclick="window.open('https://www.finereport.com/product/functions/system')"
                                      href="https://www.finereport.com/product/functions/system" target="_blank">了解更多<i
                                                class="iconfont icon-right-1-copy"></i></a>
                                    <a onclick="window.location.href='https://www.finereport.com/product/active'"
                                      href="https://www.finereport.com/product/active" rel="nofollow"
                                      class="gtm-index-cta">免费使用<i class="iconfont icon-xiazai"></i></a>
                                </div> -->
                            </div>
                            <div class="item_title" href="#design_d_02" role="tab" data-toggle="tab">
                                <h4>数据报表</h4>
                                <p>司机账单、司机保证金、车主押金、车主结算、用户提现都有非常直观的数据统计分析，方便实时了解经营情况。</p>
                                <!-- <div class="link_box">
                                    <a onclick="window.open('https://www.finereport.com/product/functions/system')"
                                      href="https://www.finereport.com/product/functions/system" target="_blank">了解更多<i
                                                class="iconfont icon-right-1-copy"></i></a>
                                    <a onclick="window.location.href='https://www.finereport.com/product/active'"
                                      href="https://www.finereport.com/product/active" rel="nofollow"
                                      class="gtm-index-cta">免费使用<i class="iconfont icon-xiazai"></i></a>
                                </div> -->
                            </div>
                            <div class="item_title" href="#design_d_03" role="tab" data-toggle="tab">
                                <h4>三方代扣</h4>
                                <p>司机可以签约三方代扣（支付宝、微信），方便快捷支付</p>
                                <!-- <div class="link_box">
                                    <a onclick="window.open('https://www.finereport.com/product/functions/system')"
                                      href="https://www.finereport.com/product/functions/system" target="_blank">了解更多<i
                                                class="iconfont icon-right-1-copy"></i></a>
                                    <a onclick="window.location.href='https://www.finereport.com/product/active'"
                                      href="https://www.finereport.com/product/active" rel="nofollow"
                                      class="gtm-index-cta">免费使用<i class="iconfont icon-xiazai"></i></a>
                                </div> -->
                            </div>
                        </div>
                        <div class="item_content_box tab-content design_d_content">
                            <div class="item_content tab-pane active" id="design_d_01">
                                <img class="img-responsive center-block"
                                    src="../assets/images/product_service19.png"
                                    alt="帆软报表,FineReport,报表系统,报表软件,报表工具,报表开发工具,数据报表,web报表,java报表,B/S报表,免费报表工具,类excel报表,数据分析工具,BI报表">
                            </div>
                            <div class="item_content tab-pane" id="design_d_02">
                                <img class="img-responsive center-block"
                                    src="../assets/images/product_service20.png"
                                    alt="帆软报表,FineReport,报表系统,报表软件,报表工具,报表开发工具,数据报表,web报表,java报表,B/S报表,免费报表工具,类excel报表,数据分析工具,BI报表">
                            </div>
                            <div class="item_content tab-pane" id="design_d_03">
                                <img class="img-responsive center-block"
                                    src="../assets/images/product_service21.png"
                                    alt="帆软报表,FineReport,报表系统,报表软件,报表工具,报表开发工具,数据报表,web报表,java报表,B/S报表,免费报表工具,类excel报表,数据分析工具,BI报表">
                            </div>
                        </div>
                    </div>

                    <div class="design_content_item tab-pane swiper-slide" id="design_e">
                        <h2 class="m_tit">数据报表</h2>
                        <div class="item_title_box design_e" role="tablist">
                            <div class="item_title active" href="#design_e_01" role="tab" data-toggle="tab">
                                <h4>数据报表集成</h4>
                                <p>从多维度数据分析集成，实时了解各业务版块经营情况。</p>
                                <!-- <div class="link_box">
                                    <a onclick="window.open('https://www.finereport.com/product/functions/system')"
                                      href="https://www.finereport.com/product/functions/system" target="_blank">了解更多<i
                                                class="iconfont icon-right-1-copy"></i></a>
                                    <a onclick="window.location.href='https://www.finereport.com/product/active'"
                                      href="https://www.finereport.com/product/active" rel="nofollow"
                                      class="gtm-index-cta">免费使用<i class="iconfont icon-xiazai"></i></a>
                                </div> -->
                            </div>
                            <div class="item_title" href="#design_e_02" role="tab" data-toggle="tab">
                                <h4>自助式BI分析</h4>
                                <p>资产统计、经营统计、运营统计、财务统计等可自由筛选统计，生成对应的折线图、柱状图，更加直观了解经营数据。</p>
                                <!-- <div class="link_box">
                                    <a onclick="window.open('https://www.finereport.com/product/functions/system')"
                                      href="https://www.finereport.com/product/functions/system" target="_blank">了解更多<i
                                                class="iconfont icon-right-1-copy"></i></a>
                                    <a onclick="window.location.href='https://www.finereport.com/product/active'"
                                      href="https://www.finereport.com/product/active" rel="nofollow"
                                      class="gtm-index-cta">免费使用<i class="iconfont icon-xiazai"></i></a>
                                </div> -->
                            </div>
                            <div class="item_title" href="#design_e_03" role="tab" data-toggle="tab">
                                <h4>可视化数据大屏</h4>
                                <p>可定制可视化数据大屏，更加直观、精准了解所有业务版块的经营数据，辅助决策分析。</p>
                                <!-- <div class="link_box">
                                    <a onclick="window.open('https://www.finereport.com/product/functions/system')"
                                      href="https://www.finereport.com/product/functions/system" target="_blank">了解更多<i
                                                class="iconfont icon-right-1-copy"></i></a>
                                    <a onclick="window.location.href='https://www.finereport.com/product/active'"
                                      href="https://www.finereport.com/product/active" rel="nofollow"
                                      class="gtm-index-cta">免费使用<i class="iconfont icon-xiazai"></i></a>
                                </div> -->
                            </div>
                        </div>
                        <div class="item_content_box tab-content design_e_content">
                            <div class="item_content tab-pane active" id="design_e_01">
                                <img class="img-responsive center-block"
                                    src="../assets/images/product_service20.png"
                                    alt="帆软报表,FineReport,报表系统,报表软件,报表工具,报表开发工具,数据报表,web报表,java报表,B/S报表,免费报表工具,类excel报表,数据分析工具,BI报表">
                            </div>
                            <div class="item_content tab-pane" id="design_e_02">
                                <img class="img-responsive center-block"
                                    src="../assets/images/product_service22.png"
                                    alt="帆软报表,FineReport,报表系统,报表软件,报表工具,报表开发工具,数据报表,web报表,java报表,B/S报表,免费报表工具,类excel报表,数据分析工具,BI报表">
                            </div>
                            <div class="item_content tab-pane" id="design_e_03">
                                <img class="img-responsive center-block"
                                    src="../assets/images/product_service23.png"
                                    alt="帆软报表,FineReport,报表系统,报表软件,报表工具,报表开发工具,数据报表,web报表,java报表,B/S报表,免费报表工具,类excel报表,数据分析工具,BI报表">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination m_design_page"></div>
            </div>

        </div>
    </section>
    <!-- 专为出行行业数字化而设计 end -->

    <!-- pc 更多场景应用让管理更加轻松 start-->
    <section class="index_enterprise_digitization_service">
      <h1>更多场景应用让管理更加轻松</h1>
      <div class="digital_solution_case">     
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/product_service24.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">司机定位地图</div>
              <div class="solution_text02">
                <div>根据司机的相关地址，地图上做打点标识，智能辅助空置车辆和司机匹配。</div>
              </div>
          </div>
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/product_service25.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">证件到期预警</div>
              <div class="solution_text02">
                <div>司机身份证、驾驶证、服务资格证到期预警，降低企业经营风险。</div>
              </div>
          </div>
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/product_service26.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">维修/保养/事故</div>
              <div class="solution_text02">
                <div>系统支持车辆维修、保养、事故等业务流程，助力企业全链路数字化。</div>
              </div>
          </div>
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/product_service27.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">年检预警</div>
              <div class="solution_text02">
                <div>根据对应的的起始日期，系统实时监控车辆年检、计价器年检、气罐年检到期时间并输出报表。</div>
              </div>
          </div>
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/product_service28.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">营销工具</div>
              <div class="solution_text02">
                <div>可自由配置优惠券、抽奖劵、电子券等营销工具，助力企业轻松实现营销方案。</div>
              </div>
          </div>
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/product_service29.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">人车实时监控</div>
              <div class="solution_text02">
                <div>基于车载智能终端设备，可实时监控车辆定位、车辆状态、驾驶员异常行为报警以及消息推送。</div>
              </div>
          </div>
          
      </div>

    </section>
    <!-- pc 更多场景应用让管理更加轻松 end-->

    <!-- mobile  更多场景应用让管理更加轻松 start -->
    <section class="mobile_enterprise_digitization_service">
      <h1> 更多场景应用让管理更加轻松</h1>
      <div class="mobile_solution_case">     
          <div class="module_solution_item">
               <div class="solution_img_wrapper">
                <img  src="../assets/images/product_service24.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">司机定位地图</div>
              <div class="solution_text02">
                <div>根据司机的相关地址，地图上做打点标识，智能辅助空置车辆和司机匹配。</div>
              </div>
          </div>
          <div class="module_solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/product_service25.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">证件到期预警</div>
              <div class="solution_text02">
                <div>司机身份证、驾驶证、服务资格证到期预警，降低企业经营风险。</div>
              </div>
          </div>
          <div class="module_solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/product_service26.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">维修/保养/事故</div>
              <div class="solution_text02">
                <div>系统支持车辆维修、保养、事故等业务流程，助力企业全链路数字化。</div>
              </div>
          </div>
          <div class="module_solution_item">
               <div class="solution_img_wrapper">
                <img  src="../assets/images/product_service27.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">年检预警</div>
              <div class="solution_text02">
                <div>根据对应的的起始日期，系统实时监控车辆年检、计价器年检、气罐年检到期时间并输出报表。</div>
              </div>
              
          </div>
          <div class="module_solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/product_service28.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">营销工具</div>
              <div class="solution_text02">
                <div>可自由配置优惠券、抽奖劵、电子券等营销工具，助力企业轻松实现营销方案。</div>
              </div>
          </div>
          <div class="module_solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/product_service29.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">人车实时监控</div>
              <div class="solution_text02">
                <div>基于车载智能终端设备，可实时监控车辆定位、车辆状态、驾驶员异常行为报警以及消息推送。</div>
              </div>
          </div>
         
      </div>
      
    </section>
    <!-- mobile  更多场景应用让管理更加轻松 end-->


    <!-- pc 平台特点 start-->
    <section class="index_enterprise_digitization_service">
      <h1>平台特点</h1>
      <div class="h_3 h_4">20年出行行业经验，因为专注所以专业。</div>
      <div class="h_3">10年技术研发沉淀，只为打造更简单、实用、智能的平台。</div>
      <div class="digital_solution_case">     
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/product_service30.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">简单易用</div>
              <div class="solution_text02">
                <div>根据生产经营流程定制开发，生产经营与平台融为一体，实用性强，易操作。</div>
              </div>
          </div>
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/product_service31.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">功能齐全</div>
              <div class="solution_text02">
                <div>围绕司机管理、资产管理、订单管理、财务管理、数据报表五个维度深度剖析细化。</div>
              </div>
          </div>
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/product_service32.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">智能辅助</div>
              <div class="solution_text02">
                <div>基于数据查询、数据实时监控、数据集成、数据可视化等技术方法，辅助经营决策分析。</div>
              </div>
          </div>
          
      </div>

    </section>
    <!-- pc 平台特点 end-->

    <!-- mobile  平台特点 start -->
    <section class="mobile_enterprise_digitization_service">
      <h1> 平台特点</h1>
      <div class="h_3 h_4">20年出行行业经验，因为专注所以专业。</div>
      <div class="h_3">10年技术研发沉淀，只为打造更简单、实用、智能的平台。</div>
      <div class="mobile_solution_case">     
          <div class="module_solution_item">
               <div class="solution_img_wrapper">
                <img  src="../assets/images/product_service30.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">简单易用</div>
              <div class="solution_text02">
                <div>根据生产经营流程定制开发，生产经营与平台融为一体，实用性强，易操作。</div>
              </div>
          </div>
          <div class="module_solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/product_service31.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">功能齐全</div>
              <div class="solution_text02">
                <div>围绕司机管理、资产管理、订单管理、财务管理、数据报表五个维度深度剖析细化。</div>
              </div>
          </div>
          <div class="module_solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/product_service32.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">智能辅助</div>
              <div class="solution_text02">
                <div>基于数据查询、数据实时监控、数据集成、数据可视化等技术方法，辅助经营决策分析。</div>
              </div>
          </div>
          
         
      </div>
      
    </section>
    <!-- mobile  平台特点 end-->

    <!--pc 立即购买 start-->
    <section class="index_free_use_buttton">
        <h3>只有快人一步，才能领先一路。</h3>
        <a class="buy-btn" @click="toBuy"><span>立即购买</span> </a>
        <div class="copy-right">
            &copy;2017-2023 杭州邮鸽网络科技有限公司版权所有  |  <span class="copy-right-number"><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer">浙ICP备17048614号</a></span>
        </div>
    </section>
    <!--pc 立即购买 end-->

    <!--mobile 立即购买 start-->
    <section class="mobile_free_use_buttton">
        <h3>只有快人一步，才能领先一路。</h3>
        <a class="buy-btn" @click="toMobileBuy"><span>立即购买</span> </a>
        <div class="copy-right">
            &copy;2017-2023 杭州邮鸽网络科技有限公司版权所有  |  <span class="copy-right-number"><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer">浙ICP备17048614号</a></span>
        </div>
    </section>
    <!--mobile 立即购买 end-->

    <pcPayment @payClose="payShow = false" :payModal="payShow"></pcPayment>

  </div>
</template>


<script>
import $ from 'jquery'


import mobileConsult from '../components/mobileConsult.vue'
import consult from '../components/consult.vue'
import toTop from '../components/toTop.vue'
import pcPayment from '../components/pcPayment.vue' 

import { Swiper } from "vue-awesome-swiper";
import 'swiper/dist/css/swiper.css'

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'productService',
  components:{
    toTop,
    consult,
    mobileConsult,
    pcPayment
  },
  computed: {
    ...mapGetters(['token'])
  },
  data(){
    return{
      mySwiper:null,
      payShow: false,
    }
  },
  mounted(){
    const type = this.$route.query.type || '';
    let rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    let rems = rootFontSize*52.08;
    if(type && type == 1){
        $('body,html').animate({scrollTop: rems}, 1);
        $(".design_title_item")[0].classList.remove("active")
        $(".design_title_item")[1].classList.add("active")
        $(".design_title_item")[2].classList.remove("active")
        $(".design_title_item")[3].classList.remove("active")
        $(".design_title_item")[4].classList.remove("active")

        $(".design_content_item")[0].classList.remove("active")
        $(".design_content_item")[1].classList.add("active")

    }else if(type && type == 2){
        $('body,html').animate({scrollTop: rems}, 1);
        $(".design_title_item")[0].classList.add("active")
        $(".design_title_item")[1].classList.remove("active")
        $(".design_title_item")[2].classList.remove("active")
        $(".design_title_item")[3].classList.remove("active")
        $(".design_title_item")[4].classList.remove("active")

        $(".design_content_item")[0].classList.add("active")
        $(".design_content_item")[1].classList.remove("active")
    }else if(type && type == 3){
        $('body,html').animate({scrollTop: rems}, 1);
        $(".design_title_item")[0].classList.remove("active")
        $(".design_title_item")[1].classList.remove("active")
        $(".design_title_item")[2].classList.add("active")
        $(".design_title_item")[3].classList.remove("active")
        $(".design_title_item")[4].classList.remove("active")

        $(".design_content_item")[0].classList.remove("active")
        $(".design_content_item")[1].classList.remove("active")
        $(".design_content_item")[2].classList.add("active")
    }else if(type && type == 4){
        $('body,html').animate({scrollTop: rems}, 1);
        $(".design_title_item")[0].classList.remove("active")
        $(".design_title_item")[1].classList.remove("active")
        $(".design_title_item")[2].classList.remove("active")
        $(".design_title_item")[3].classList.add("active")
        $(".design_title_item")[4].classList.remove("active")

        $(".design_content_item")[0].classList.remove("active")
        $(".design_content_item")[1].classList.remove("active")
        $(".design_content_item")[2].classList.remove("active")
        $(".design_content_item")[3].classList.add("active")
    }else{
        $('body,html').animate({scrollTop: 0}, 1);
    }
    

    
    
    $(".design_title_item").on('click', function () {
        $(this).addClass("active").siblings().removeClass("active")
    }).on('mouseenter', function () {
        $(this).addClass("active").siblings().removeClass("active");
        //$(this).tab('show');
    });
  
    $(".item_title").click(function () {
        $(this).addClass("active").siblings().removeClass("active")
    });
    window.addEventListener('resize', this.setRemUnit02)
    // if ($(window).width() <= 1200) {
    //     this.mySwiper = new Swiper('.m_design_swiper', {
    //         slidesPerView: 1.05,
    //         spaceBetween: 20,
    //         pagination: {
    //             el: '.m_design_page',
    //             clickable: true,
    //         },
    //     });
    //     $(".scene_info_top").click(function () {
    //         $(this).parents(".scene_box").toggleClass("active").siblings(".scene_box").removeClass("active")
    //     })
    // }
    this.mySwiper = new Swiper('.m_design_swiper', {
        slidesPerView: 1.05,
        spaceBetween: 20,
        pagination: {
            el: '.m_design_page',
            clickable: true,
        },
    });
    $(".scene_info_top").click(function () {
        $(this).parents(".scene_box").toggleClass("active").siblings(".scene_box").removeClass("active")
    })

    $(".design_a>.item_title").hover(function () {
        let index = $(this).index();
        $(".design_a>.item_title").eq(index).addClass("active").siblings().removeClass('active');
        $(".design_a_content>.item_content").eq(index).addClass("active").siblings().removeClass('active');
    });

    $(".design_b>.item_title").hover(function () {
        let index = $(this).index();
        $(".design_b>.item_title").eq(index).addClass("active").siblings().removeClass('active');
        $(".design_b_content>.item_content").eq(index).addClass("active").siblings().removeClass('active');
    });

    $(".design_c>.item_title").hover(function () {
        let index = $(this).index();
        $(".design_c>.item_title").eq(index).addClass("active").siblings().removeClass('active');
        $(".design_c_content>.item_content").eq(index).addClass("active").siblings().removeClass('active');
    });

    $(".design_d>.item_title").hover(function () {
        let index = $(this).index();
        $(".design_d>.item_title").eq(index).addClass("active").siblings().removeClass('active');
        $(".design_d_content>.item_content").eq(index).addClass("active").siblings().removeClass('active');
    });

    $(".design_e>.item_title").hover(function () {
        let index = $(this).index();
        $(".design_e>.item_title").eq(index).addClass("active").siblings().removeClass('active');
        $(".design_e_content>.item_content").eq(index).addClass("active").siblings().removeClass('active');
    });
  },
  methods: {
    setRemUnit02(){
      if ($(window).width() >= 768) {
        this.mySwiper = new Swiper('.m_design_swiper', {
            slidesPerView: 1.05,
            spaceBetween: 20,
            pagination: {
                el: '.m_design_page',
                clickable: true,
            },
        });
        $(".scene_info_top").click(function () {
            $(this).parents(".scene_box").toggleClass("active").siblings(".scene_box").removeClass("active")
        })
      }
      if ($(window).width() >= 768) {
        this.$router.go(0);
      }
    },
    toBuy(){
        if (this.token) {
            this.payShow = true;
        } else {
            this.$router.push({
                path: '/login'
            })
        }
    },
    // 移动端模式的购买跳转
    toMobileBuy(){
        if (this.token) {
            this.payShow = true;
        } else {
            this.$router.push({
                path: '/login'
            })
        }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.home-wrapper01{
    width: 100%;
    height: 35.42rem;
    background: url('https://yoogurt.oss-cn-hangzhou.aliyuncs.com/bbc/product_service01.png');
    background-size: 100% 100%;
    .wrapper01-main{
      margin-left: 20rem;
      padding-top: 7.4rem;
      .text01{
        color: rgb(0, 105, 234);
        font-family: PingFang SC;
        font-size: $fontSize24;
        font-weight: 400;
        line-height: $fontSize36;
        letter-spacing: 0px;
        text-align: left;
      }
      .text02{
        color: rgb(0, 105, 234);
        font-family: PingFang SC;
        font-size: 3.4375rem;
        font-weight: 400;
        line-height: $fontSize45;
        letter-spacing: 0px;
        text-align: left;
        font-weight: 500;
      }
      .text03{
        color: rgb(51, 51, 51);
        font-family: PingFang SC;
        font-size: $fontSize20;
        font-weight: 500;
        line-height: $fontSize30;
        letter-spacing: 0px;
        text-align: left;
        margin-top: $fontSize30;
      }
    }
}

.index_home-wrapper02{
  display: flex;
  justify-content: space-around;
  margin-top: 4rem;
  padding: 0 20rem;
  padding-bottom: 4rem;
  .wrapper02-main{
    display: flex;
    flex-direction: column;
    align-items: center;
    .wrapper02-main01{
        display: flex;
        align-items: center;
        justify-content: center;
        .img01{
        width: 3.334rem;
        height: 3.334rem;
        }
    }
    .wrapper02-main02{
        margin-top: 0.8rem;
        font-size: $fontSize18;
        color: rgb(51, 51, 51);
    }
    .wrapper02-main03{
        margin-top: 0.2rem;
        font-size: $fontSize18;
        color: rgb(128, 141, 161);
    }
  } 
}


.copy-right-number>a {
  color: #0069EA;
}
@media (max-width: 1200px) {
    .indedx_design {
        padding-top: $mFontSize20;
    }
}
.indedx_design .title{
    font-size: $fontSize45 !important;
    margin-top: 3rem;
    margin-bottom: 2rem !important;
}
.indedx_design .design_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 70px;
    padding-right: 70px;
    margin-bottom: 60px;
}

@media (max-width: 1200px) {
    .indedx_design .design_title {
        display: none;
    }
}

/*.indedx_design .design_title p {*/
/*    margin-top: -30px;*/
/*}*/

/*.indedx_design .design_title p span {*/
/*    width: 17px;*/
/*    height: 17px;*/
/*    display: inline-block;*/
/*    border-left: 3px solid #0069ea;*/
/*    border-top: 3px solid #0069ea;*/
/*    -webkit-transform: rotate(-225deg) !important;*/
/*    transform: rotate(-225deg) !important;*/

/*}*/

/*.indedx_design .design_title p span:nth-child(1) {*/
/*    opacity: 1;*/
/*    -webkit-animation: fadeInDown 2s linear infinite;*/
/*    animation: fadeInDown 2s linear infinite;*/
/*}*/

/*.indedx_design .design_title p span:nth-child(2) {*/
/*    opacity: 0.5;*/
/*    -webkit-animation: fadeInDown 2s 0.5s linear infinite;*/
/*    animation: fadeInDown 2s 0.5s linear infinite;*/
/*}*/

/*.indedx_design .design_title p span:nth-child(3) {*/
/*    opacity: 0.2;*/
/*    -webkit-animation: fadeInDown 2s 1s linear infinite;*/
/*    animation: fadeInDown 2s 1s linear infinite;*/
/*}*/

/***/
.indedx_design .design_title .design_ani_item {
    position: relative;
    top: -20px;
    width: 50px;
}

@-webkit-keyframes indedx_design_arrow-move {
    0% {
        left: 0%;
        opacity: 0
    }
    70% {
        opacity: 1
    }
    to {
        opacity: 0
    }
}

@-moz-keyframes indedx_design_arrow-move {
    0% {
        left: 0%;
        opacity: 0
    }
    70% {
        opacity: 1
    }
    to {
        opacity: 0
    }
}

@keyframes indedx_design_arrow-move {
    0% {
        left: 0%;
        opacity: 0
    }
    70% {
        opacity: 1
    }
    to {
        opacity: 0
    }
}

.indedx_design .design_title .design_ani_item .arrow{
    position: absolute;
    top: 50%;
    left: 60%;
    transform: translate3d(-50%,-50%,0);
    transform-origin: 50% 50%;
}

.indedx_design .design_title .design_ani_item .arrow>em {
    width: 17px;
    height: 17px;
    display: inline-block;
    border-left: 3px solid #0069ea;
    border-top: 3px solid #0069ea;
    -webkit-transform: rotate(-225deg) !important;
    transform: rotate(-225deg) !important;
}

.indedx_design .design_title .design_ani_item .arrow:nth-child(1) {
    animation: indedx_design_arrow-move 2.4s ease-in-out infinite;
}
.indedx_design .design_title .design_ani_item .arrow:nth-child(2) {
    animation: indedx_design_arrow-move 2.4s ease-in-out 0.8s infinite;
}
.indedx_design .design_title .design_ani_item .arrow:nth-child(3) {
    animation: indedx_design_arrow-move 2.4s ease-in-out 1.6s infinite;
}

.indedx_design .design_title .design_title_item {
    cursor: pointer;
}

.indedx_design .design_title .design_title_item .img_box {
    width: 144px;
    height: 144px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    transition: all 0.5s;
}

.indedx_design .design_title .design_title_item h5 {
    font-size: 20px;
    font-weight: 400;
    color: #808DA1;
    line-height: 28px;
    margin-top: 20px;
    margin-bottom: 0;
    transition: all 0.5s;
}

.indedx_design .design_title .design_title_item:nth-of-type(1) .img_box {
    background-image: url('../assets/images/product_service05.png');
}

.indedx_design .design_title .design_title_item:nth-of-type(3) .img_box {
    background-image: url('../assets/images/product_service06.png');
}

.indedx_design .design_title .design_title_item:nth-of-type(5) .img_box {
    background-image: url('../assets/images/product_service07.png');
}

.indedx_design .design_title .design_title_item:nth-of-type(7) .img_box {
    background-image: url('../assets/images/product_service08.png');
}

.indedx_design .design_title .design_title_item:nth-of-type(9) .img_box {
    background-image: url('../assets/images/product_service09.png');
}

.indedx_design .design_title .design_title_item:hover h5,
.indedx_design .design_title .design_title_item.active h5 {
    color: #0069EA;
}

.indedx_design .design_title .design_title_item:hover:nth-of-type(1) .img_box,
.indedx_design .design_title .design_title_item.active:nth-of-type(1) .img_box {
    background-image: url('../assets/images/product_service05_active.png');
}

.indedx_design .design_title .design_title_item:hover:nth-of-type(3) .img_box,
.indedx_design .design_title .design_title_item.active:nth-of-type(3) .img_box {
    background-image: url('../assets/images/product_service06_active.png');
}

.indedx_design .design_title .design_title_item:hover:nth-of-type(5) .img_box,
.indedx_design .design_title .design_title_item.active:nth-of-type(5) .img_box {
    background-image: url('../assets/images/product_service07_active.png');
}

.indedx_design .design_title .design_title_item:hover:nth-of-type(7) .img_box,
.indedx_design .design_title .design_title_item.active:nth-of-type(7) .img_box {
    background-image: url('../assets/images/product_service08_active.png');
}

.indedx_design .design_title .design_title_item:hover:nth-of-type(9) .img_box,
.indedx_design .design_title .design_title_item.active:nth-of-type(9) .img_box {
    background-image: url('../assets/images/product_service09_active.png');
}

@media (max-width: 1200px) {
    .indedx_design .m_design_swiper {
        padding: 5px 15px 15px;
        margin-left: -15px;
        margin-right: -15px;
    }
}

.indedx_design .design_content {
    width: auto;
    margin: 0;
}

@media (max-width: 1200px) {
    .indedx_design .design_content {
        width: auto;
    }
}

.indedx_design .m_design_page {
    display: none;
}

@media (max-width: 1200px) {
    .indedx_design .m_design_page {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .indedx_design .m_design_page .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        background: rgba(0, 105, 234, 0.3);
        border-radius: 4px;
        opacity: 1;
    }

    .indedx_design .m_design_page .swiper-pagination-bullet.swiper-pagination-bullet-active {
        width: 40px;
        height: 8px;
        background: #0069EA;
        border-radius: 4px;
    }
}
.swiper-container-horizontal > .swiper-pagination{
  position: relative;
  // margin-top: 12px;
}
.indedx_design .design_content_item {
    justify-content: space-between;
    align-items: unset;
}

@media (max-width: 1200px) {
    .indedx_design .design_content_item {
        display: flex;
        flex-wrap: wrap;
        background: #FFFFFF;
        box-shadow: 0px 2px 10px 0px rgba(184, 187, 204, 0.5);
        border-radius: 8px;
        padding: 25px 10px 20px;
    }
}

.indedx_design .design_content_item .m_tit {
    display: none;
}

@media (max-width: 1200px) {
    .indedx_design .design_content_item .m_tit {
        display: block;
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        line-height: 25px;
        margin-bottom: 15px;
        margin-top: 0;
    }
}

.indedx_design .design_content_item.active {
    display: flex;
}

.indedx_design .item_title_box {
    width: 380px;
}

@media (max-width: 1200px) {
    .indedx_design .item_title_box {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
    }
}

.indedx_design .item_title_box .item_title {
    width: 100%;
    height: 128px;
    border-radius: 2px;
    background-image: url('https://src.fanruan.com/website/finereport/design_contentbg.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    margin-bottom: 14px;
    padding: 32px 70px 0 40px;
    cursor: pointer;
}

@media (max-width: 1200px) {
    .indedx_design .item_title_box .item_title {
        width: 30%;
        height: auto;
        padding: 10px 0;
        background: #EFF5FF;
        border-radius: 6px;
        margin-bottom: 0;
    }
}

@media (max-width: 768px) {
    .indedx_design .item_title_box .item_title {
        width: 30%;
        padding: 0;
        height: 30px;
        background: #EFF5FF;
        border-radius: 4px;
        margin-bottom: 0;
        overflow: hidden;
    }
    .indedx_design .title{
        font-size: $mFontSize20 !important;
        margin-top: 0rem;
        margin-bottom: 4rem !important;
    }
}

.indedx_design .item_title_box .item_title h4 {
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 25px;
    margin-top: 0;
    margin-bottom: 8px;
}

@media (max-width: 1200px) {
    .indedx_design .item_title_box .item_title h4 {
        font-size: 16px;
        text-align: center;
        margin-bottom: 0;
        line-height: 40px;
    }
}

@media (max-width: 768px) {
    .indedx_design .item_title_box .item_title h4 {
        font-size: 14px;
        text-align: center;
        margin-bottom: 0;
        line-height: 30px;
    }
}

.indedx_design .item_title_box .item_title p {
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    line-height: 17px;
}

@media (max-width: 1200px) {
    .indedx_design .item_title_box .item_title p {
        display: none;
    }
}

.indedx_design .item_title_box .item_title .link_box {
    display: none;
}

.indedx_design .item_title_box .item_title .link_box a {
    width: 96px;
    height: 30px;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 30px;
    margin-right: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.indedx_design .item_title_box .item_title .link_box a i {
    font-size: 16px;
}

.indedx_design .item_title_box .item_title:last-of-type {
    margin-bottom: 0;
}

.indedx_design .item_title_box .item_title.active {
    height: 160px;
    background-image: url('https://src.fanruan.com/website/finereport/design_contentbg_hover.png');
    // padding: 20px 95px 0 35px;
    box-shadow: 0px 2px 8px 0px rgba(0, 105, 234, 0.4);
}

@media (max-width: 1200px) {
    .indedx_design .item_title_box .item_title.active {
        height: auto;
        padding: 10px 0;
    }
}

@media (max-width: 768px) {
    .indedx_design .item_title_box .item_title.active {
        padding: 0;
        height: 30px;
    }
}

.indedx_design .item_title_box .item_title.active h4 {
    color: #FFFFFF;
}

.indedx_design .item_title_box .item_title.active p {
    margin-bottom: 15px;
    color: #C0D7F3;
}

.indedx_design .item_title_box .item_title.active .link_box {
    display: flex;
}

@media (max-width: 1200px) {
    .indedx_design .item_title_box .item_title.active .link_box {
        display: none;
    }
}

.indedx_design .item_content_box {
    width: 740px;
    height: 448px;
    background: #E9F1FD;
    box-shadow: 0px 2px 8px 0px rgba(0, 105, 234, 0.3), inset 0px -2px 3px 0px rgba(255, 255, 255, 0.8);
    border-radius: 2px;
    padding: 10px;
}

@media (max-width: 1200px) {
    .indedx_design .item_content_box {
        width: 100%;
        height: auto;
    }
}

.indedx_design .item_content_box img {
    max-width: 100%;
}


/*pc  为企业数字化提供全方位服务  */ 
.mobile_enterprise_digitization_service{
  display: none;
}
.index_enterprise_digitization_service{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // height: 40.3158rem;
  width: 100%;
  // background-color: rgb(239, 245, 255);
  h1{
    color: rgb(51, 51, 51);
    font-family: PingFang SC;
    font-size: $fontSize45;
    font-weight: 500;
    padding: 2rem 0;
  }
  .h_3{
    color: rgb(102, 102, 102);
    font-family: PingFang SC;
    font-size: $fontSize15;
  }
  .h_4{
    margin-top: -$fontSize32;
  }
  .digital_solution_case {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    // height: 37.7368rem;
    width: 100%;
    .solution_img_box {
      height: 16.8421rem;
      width: 21.3158rem;
      margin-right: 1.5263rem;
      border-radius: 6px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      overflow: hidden;
    }
    img {
      width: 100%;
      height: 100%;
    }
    .solution_item {
      height: 16.8421rem;
      width: 28.89rem;
      margin: .6316rem;
      box-shadow: 0px 4px 14px 0px rgba(204, 213, 222, 0.5);
      border-radius: 8px;
      background: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      .solution_text01{
        color: rgb(51, 51, 51);
        font-family: PingFang SC;
        font-size: $fontSize32;
        font-weight: 500;
        margin-top: 1.125rem;
        margin-bottom: 1.2rem;
      }
      .solution_text02{
        color: rgb(51, 51, 51);
        font-family: PingFang SC;
        font-size: $fontSize14;
        text-align: center;
        width: 20rem;
      }
      .solution_img_wrapper{
        width: 4.16667rem;
        height: 4.16667rem;
        margin-top: 2.8rem;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .solution_item:hover{
      background: url('../assets/images/home-bg03.png');
      background-size: cover;
      .solution_text01{
        color: #FFFFFF;
      }
      .solution_text02{
        color: #FFFFFF;
      }
    }
  }
}     

/* 一站式出行行业数字化解决方案服务商 */ 
.mobile_free_use_buttton{
    display: none;
}
.index_free_use_buttton {
    display: block;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 18.33rem;
    background-image: url("../assets/images/home-bg04.png");
    background-size: cover;
    .copy-right{
      color: rgb(51, 51, 51);
      font-size: $fontSize18;
      font-weight: 500;
      line-height: 1;
      letter-spacing: 0;
      text-align: center;
      margin-top: 2.5rem;
    }
    h3 {
        margin: 4.211rem 0 .632rem 0;
        font-size: 1.684rem;
        font-family: "PingFang-SC";
        font-weight: 600;
        color: #333333;
    }
    .buy-btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 19.474rem;
        height: 3.158rem;
        background: #0069EA;
        border-radius: 4px;
        margin-top: 2rem;
        cursor: pointer;
        span {
            font-size: $fontSize24;
            font-family: PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
        }

    }
}

// 移动端
@media screen and (min-width: 300px) and (max-width: 768px) {
    .home-wrapper01{
        width: 100%;
        height: 35.42rem;
        background: url('https://yoogurt.oss-cn-hangzhou.aliyuncs.com/bbc/product_service01.png');
        background-size: 100% 100%;
        .wrapper01-main{
            margin-left: 3rem;
            padding-top: 7.4rem;
            .text01{
            color: rgb(0, 105, 234);
            font-family: PingFang SC;
            font-size: $mFontSize12;
            font-weight: 400;
            line-height: $fontSize45;
            letter-spacing: 0px;
            text-align: left;
            }
            .text02{
            color: rgb(0, 105, 234);
            font-family: PingFang SC;
            font-size: $mFontSize20;
            font-weight: 400;
            line-height: $mFontSize20;
            letter-spacing: 0px;
            text-align: left;
            font-weight: 500;
            margin-top: $fontSize45;
            }
            .text03{
            color: rgb(51, 51, 51);
            font-family: PingFang SC;
            font-size: $mFontSize12;
            font-weight: 500;
            line-height: $fontSize30;
            letter-spacing: 0px;
            text-align: left;
            margin-top: $fontSize45;
            }
        }
    }
    .index_home-wrapper02{
        display: flex;
        justify-content: space-around;
        margin-top: 4rem;
        padding: 0 1rem;
        padding-bottom: 2rem;
        .wrapper02-main{
            display: flex;
            flex-direction: column;
            align-items: center;
            .wrapper02-main01{
                display: flex;
                align-items: center;
                justify-content: center;
                .img01{
                    width: 6.65rem;
                    height: 6.875rem;
                }
                .img02{
                    width: 2.5rem;
                    height: 3rem;
                }
            }
            .wrapper02-main02{
                margin-top: $mFontSize12;
                font-size: $mFontSize12;
            }
            .wrapper02-main03{
                margin-top: 1rem;
                font-size: $mFontSize12;
            }
        }
        
    }

    .index_enterprise_digitization_service{
        display: none;
    }
    .mobile_enterprise_digitization_service{
        display: block;
        display: flex;
        flex-direction: column;
        align-items: center;
        // height: 104rem;
        // background-color: rgb(239, 245, 255);
        h1{
            font-size: 5.1429rem;
            margin: 5.2rem 0;
        }
        .h_3{
            color: rgb(102, 102, 102);
            font-family: PingFang SC;
            font-size: $mFontSize12;
            margin-bottom: 1rem;
        }
        .h_4{
            margin-top: -1.8rem;
        }
        .mobile_solution_case {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            width: 97.1429rem;
        
        }
        .module_solution_item {
            border-radius: 2px;
            height: 43rem;
            width: 45.7143rem;
            box-shadow: 0px 4px 14px 0px rgba(204, 213, 222, 0.5);
            margin: 0 1.2rem 2.4rem 1.2rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            .solution_text01{
            font-size: $mFontSize16;
            margin:1.8rem 0;
            }
            .solution_text02{
            font-size: $mFontSize12;
            text-align: center;
            margin: 0 1rem;
            }
            .solution_img_wrapper{
            width: 12rem;
            height: 12rem;
            margin-top: 1.8rem;
            img{
                width: 100%;
                height: 100%;
            }
            }
        }
    }

    .index_free_use_buttton{
        display: none;
    }
    .mobile_free_use_buttton{
        display: block;
        width: 100%;
        height: 180px;
        display: flex;
        flex-direction: column;
        align-items: center;
    
        background-image: url("../assets/images/home-bg04.png");
        background-size: cover;
        .copy-right{
            margin-top: 2.5rem;
            font-size: $mFontSize12;
            text-align: center;
            padding: 0 2rem;
            font-weight: normal;
        }
        h3{
            font-size: $mFontSize16;
        }
        .buy-btn {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            background: #0069EA;
            border-radius: 4px;
            display: inline-block;
            width: 180px;
            height: 36px;
            margin-top: 2rem;
            text-align: center;
            line-height: 36px;
            span{
                font-size: 14px;
                color: #FFFFFF;
            }
        }
    }
  
}
</style>
